// extracted by mini-css-extract-plugin
export default {"container":"VCysAWGJ","loader":"_T59myeL"};